<template>
  <div class="page">
    <p v-if="fileType == 0">{{ $t('product.notSpecific') }}</p>
    <template v-if="fileType != 0">
      <div class="card">
        <p class="f16 mb10">{{ $t('product.importFile') }}</p>
        <div class="upload-container">
          <div class="upload-btn">
            <el-button type="primary" icon="el-icon-upload" plain>{{ $t('product.uploadFile') }}</el-button>
            <input @change="changeFile" :accept="fileType === 1 ? '.csv' : '.xls,.xlsx'" type="file" />
          </div>
          <el-button type="text" @click="downloadTemplate">{{ $t('common.download', [' ']) }}{{ $t('common.template') }}</el-button>
        </div>
        <p class="mt10 gray">{{ $t('product.supportSuffix', [fileType === 1 ? '.csv' : '.xls .xlsx']) }}</p>
        <div class="file-item bg-gray" v-if="selectFileName"><i class="el-icon-document"></i> {{ selectFileName }}</div>
        <div class="mt20">
          <el-button class="mb10" type="primary" @click="submitUpload(1)">{{ $t('product.allUpdate') }}</el-button>
          <el-button class="mb20" type="primary" @click="submitUpload(2)">{{ $t('product.someUpdate') }}</el-button>
        </div>
      </div>

      <el-table class="spacing-table" v-loading="loading" :data="tableData">
        <el-table-column prop="taskName" :label="$t('common.taskName')" min-width="150"></el-table-column>
        <el-table-column prop="createdAt" :label="$t('common.startDate')" min-width="150"></el-table-column>
        <el-table-column :label="$t('common.status')">
          <template slot-scope="scope">
            <span
              :class="{
                green: scope.row.status === 'Success' || scope.row.status === '成功',
                red: scope.row.status === 'Failed' || scope.row.status === '失败',
              }"
              >{{ scope.row.status }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="fileReport" :label="$t('product.fileReport')" min-width="200"></el-table-column>
        <el-table-column :label="$t('common.result')" min-width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.data.total != undefined"> total {{ scope.row.data.total }}, </template>
            <template v-if="scope.row.data.total != undefined && scope.row.data.failedCount != undefined">
              success: {{ scope.row.data.total - scope.row.data.failedCount }},
            </template>
            <template v-if="scope.row.data.failedCount != undefined"> Faild: {{ scope.row.data.failedCount }} </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.wasteTime')" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.costTime != null ? scope.row.costTime / 1000 + $t('common.s') : '' }}
          </template>
        </el-table-column>
        <el-table-column width="250" :label="$t('common.action')">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              v-if="scope.row.status !== '导入中' && scope.row.status !== 'Importing' && scope.row.data.importUrl"
              @click="downloadResult(scope.row.data.importUrl)"
              >Import File</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="scope.row.status !== '导入中' && scope.row.status !== 'Importing' && scope.row.data.resultUrl"
              @click="downloadResult(scope.row.data.resultUrl)"
              >{{ $t('common.download', [' ']) }}{{ $t('common.result') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </template>
  </div>
</template>

<script>
import {
  importOrExportManagerTask,
  uploadSpecificProductAllUpdate,
  uploadSpecificProductSomeUpdate,
  selectImportFileIoByVendorId,
  selectImportTypeByVendorId,
} from '../../api/product';
import { downloadBlobFile, downloadUrlFile } from '../../common/utils';

export default {
  name: 'ProductSpecificImport',
  data() {
    return {
      loading: true,
      queryForm: {
        pageNo: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      selectFileName: '',
      fileType: 1, // 1csv 2excel
    };
  },
  created() {
    this.loading = true;
    selectImportTypeByVendorId().then((res) => {
      this.fileType = res.data;
      this.loading = false;
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      importOrExportManagerTask({
        ...this.queryForm,
        taskCode: 'Specific Product Import',
      }).then((res) => {
        this.total = res.data.total || 0;
        this.tableData = (res.data.list || []).map((item) => {
          try {
            item.data = JSON.parse(item.data);
            item.fileReport = item.data.fileReport;
          } catch (error) {
            // nothing
          }
          return item;
        });
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    downloadResult(url) {
      downloadUrlFile(url);
    },
    changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (this.fileType === 1 && !/\.csv$/.test(String(file.name).toLowerCase())) {
          this.$message.error(this.$t('product.supportSuffix', ['.csv']));
        } else if (this.fileType === 2 && !/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error(this.$t('product.supportSuffix', ['.xls .xlsx']));
        } else if (file.size > 50 * 1024 * 1024) {
          this.$message.error(this.$t('product.fileTooLarge'));
        } else {
          this.selectFileName = file.name;
          this.selectFile = file;
        }
      }
      e.target.value = '';
    },
    submitUpload(type) {
      if (!this.selectFile) {
        this.$message('请选择文件');
        return;
      }
      this.$msgbox({
        title: this.$t('common.tip'),
        message: type === 2 ? this.$t('product.updateOnlyItems') : this.$t('product.willBeCleared'),
        showCancelButton: true,
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(() => {
        const formData = new FormData();
        formData.append('file', this.selectFile);
        let request = uploadSpecificProductAllUpdate;
        if (type === 2) {
          request = uploadSpecificProductSomeUpdate;
        }
        request(formData).then((res) => {
          if (res.code === '1' || res.code === 1) {
            this.$message.error(this.$t('product.importingLater'));
            this.getTableData();
            return;
          }
          if (res.code === '3' || res.code === 3) {
            this.$message.error(res.message);
            this.getTableData();
            return;
          }
          this.selectFileName = '';
          this.selectFile = null;
          this.getTableData();
        });
      });
    },
    downloadTemplate() {
      selectImportFileIoByVendorId().then((res) => {
        downloadBlobFile(res.data, this.fileType === 1 ? 'template.csv' : 'template.xlsx');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
</style>
